export default {
  controlinetpays: {
    title: "Control over internet payments",
    displayPayment: {
      title: "Show payments",
      payAll: "All",
      payMoneyReceived: "For which money was received",
      payMoneyNotReceived: "For which money was not received",
      payPersonalAccounts: "Display personal accounts payments"
    },
    reportingMonthColumn: {
      headers: {
        reportingMonth: "Reporting month"
      }
    },
    paymentSenderColumn: {
      headers: {
        paymentSender: "Payment sender"
      }
    },
    inetPayNotConnectedPaymentsColumn: {
      headers: {
        inetPayNotConnectedPayments: "Internet payments not related to payments"
      }
    },
    personalAccountsPaymentsColumn: {
      headers: {
        abcodeLong: "Personal account",
        payment: "Payment",
        registry: "Registry"
      }
    },
    moveToNextMonth: {
      confirm: {
        transferPaymentsFrom: "Transfer payments from",
        for: "from",
        on: "to",
        title: "Transfer to next month"
      }
    },
    cancelReceivedRegistry: {
      confirm: {
        сancelRegistry: "Cancel registry",
        from: "from",
        behind: "for",
        title: "Cancelling of received registry"
      }
    },
    cancelSubscriberPayment: {
      confirm: {
        сancelSubscriberPayment: "Cancel subscriber payment",
        behind: "for",
        on: "on",
        title: "Cancelling subscriber payment"
      }
    }
  }
};
